import { localStorageInstance } from '@gem/modules/storage';

import { IStickerPacks } from 'APP/store/Stickers/Stickers';

const KEY_NAME = 'installed_sticker_packs';

interface IInstalledStickerPack {
  packs: IStickerPacks;
  lastUpdateTime: number;
}

export const get = (): IInstalledStickerPack | null => {
  const data = localStorageInstance.getItem(KEY_NAME);

  if (!data) {
    return null;
  }

  try {
    const { lastUpdateTime, packs } = JSON.parse(data);

    return {
      lastUpdateTime,
      packs,
    };
  } catch (error) {
    return null;
  }
};

export const set = ({ packs, lastUpdateTime }: IInstalledStickerPack): void => {
  const data = JSON.stringify({
    lastUpdateTime,
    packs,
  });

  return localStorageInstance.setItem(KEY_NAME, data);
};

export const remove = (): void => localStorageInstance.removeItem(KEY_NAME);
